/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SysqueLocationOptionsLineComponent } from './sysque-location-options-line.component';
import { DxTextBoxModule } from 'devextreme-angular';

@NgModule({
  declarations: [SysqueLocationOptionsLineComponent],
  imports: [CommonModule, DxTextBoxModule],
  exports: [SysqueLocationOptionsLineComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SysqueLocationOptionsLineModule {}
